<script setup lang="ts">
import ChapterExercisePage from "~/features/computer/components/ChapterExercisePage.vue";
</script>

<template>
  <ChapterExercisePage unit="digital-literacy" />
</template>
